import { B2bOperationsErList } from '@sh4res/bo-common/components/B2bOperationsEr/B2bOperationsErList';

import { ResourceDefinition } from '@Utils/types';

export const operationsErResource: ResourceDefinition = {
  options: { label: 'menu.operations_er' },
  list: (props) => <B2bOperationsErList {...props} />,
};
